import { useMemo, useState } from "react";
import { timeZoneOptions } from "@/utils/datetime";
import { useAuth } from "@/auth/AuthContext";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function DateTimePreferences() {
  const { user, updateDisplayPreferences } = useAuth();
  const [open, setOpen] = useState(false);
  const [zone, setZone] = useState("");
  const [format, setFormat] = useState("locale");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const zones = useMemo(() => timeZoneOptions([user?.display_time_zone, Intl.DateTimeFormat().resolvedOptions().timeZone]), [user?.display_time_zone]);
  const save = async (event) => {
    event.preventDefault(); setError(""); setSaving(true);
    try {
      if (zone) new Intl.DateTimeFormat("en", { timeZone: zone });
      await updateDisplayPreferences({ display_time_zone: zone, date_format: format });
      setOpen(false);
    } catch (failure) {
      const detail = failure.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Choose a valid time zone, then try saving again.");
    } finally { setSaving(false); }
  };
  return <>
    <button type="button" data-testid="date-time-preferences-button" onClick={() => {
      setZone(user?.display_time_zone || ""); setFormat(user?.date_format || "locale"); setError(""); setOpen(true);
    }}>Time &amp; date</button>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader><DialogTitle>Time and date display</DialogTitle><DialogDescription>Choose how dates and activity times appear for your account.</DialogDescription></DialogHeader>
        <form onSubmit={save} className="date-preferences-form">
          <label>Time zone
            <input aria-label="Display time zone" list="display-time-zones" value={zone} onChange={(event) => setZone(event.target.value)} placeholder={`Automatic — ${Intl.DateTimeFormat().resolvedOptions().timeZone}`} />
            <datalist id="display-time-zones">{zones.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}</datalist>
          </label>
          <small>Start typing a city or region (for example "Chicago" or "Tokyo") and pick any time zone from the list. Leave blank to follow your device. Project deadlines use the job-site time zone.</small>
          <label>Date format
            <select aria-label="Date format" value={format} onChange={(event) => setFormat(event.target.value)}>
              <option value="locale">Follow device</option><option value="mdy">MM/DD/YYYY</option><option value="dmy">DD/MM/YYYY</option><option value="iso">YYYY-MM-DD</option>
            </select>
          </label>
          {error && <p role="alert">{error}</p>}
          <button type="submit" disabled={saving}>{saving ? "Saving…" : "Save preferences"}</button>
        </form>
      </DialogContent>
    </Dialog>
  </>;
}
